// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorMe = (client) => ({
    /**
     * `GET /vendor/me`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetMemberMe
     * @source packages/modules/b2c-core/src/api/vendor/me/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/me", { method: "GET", query, headers }),
    /**
     * `POST /vendor/me/phone/verify-request`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorMePhoneVerifyRequestPost
     * @source apps/backend/src/api/vendor/me/phone/verify-request/route.ts
     */
    updatePhoneVerifyRequest: (body, query, headers) => client.fetch("/vendor/me/phone/verify-request", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/me/phone/verify`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorMePhoneVerifyPost
     * @source apps/backend/src/api/vendor/me/phone/verify/route.ts
     */
    verifyPhone: (body, query, headers) => client.fetch("/vendor/me/phone/verify", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=me.js.map